import React, {ButtonHTMLAttributes, forwardRef} from 'react';
import {cn} from '../../libs';

interface ButtonSquareProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children?: React.ReactNode;
}

/**
 * @deprecated Use Button instead, with shape="square"
 */
export const ButtonSquare = forwardRef<HTMLButtonElement, ButtonSquareProps>(function ButtonSquare(
  {children, className, ...rest},
  ref,
) {
  return (
    <button
      {...rest}
      ref={ref}
      className={cn(
        'flex size-10 cursor-pointer items-center justify-center rounded-md border bg-bg-secondary text-text-secondary transition-all',
        'hover:bg-bg-secondary-hover',
        'disabled:bg-bg-secondary-hover',
        'disabled:text-text-disabled',
        'disabled:pointer-events-none',
        className,
      )}
      type="button"
    >
      {children}
    </button>
  );
});
